<template>
  <span class="rating">
    <div class="rating-wrapper">
      <span class="rating-active" :style="ratingStyle">
        <i 
          class="fas fa-star" 
          :class="ratingClass"
          aria-hidden="true"
          v-for="rating in ratings"
          :key="rating">
        </i>
      </span>
      <span class="rating-inactive">
        <i 
          class="far fa-star" 
          :class="ratingClass"
          aria-hidden="true"
          v-for="rating in ratings"
          :key="`${rating}-placeholder`">
        </i>
      </span>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    stars: {
      type: Number,
      default: 5
    },
    isMedium: {
      type: Boolean
    },
    isLarge: {
      type: Boolean
    }
  },
  computed: {
    ratings({ stars }) {
      return Array(stars).fill().map((_, i) => i+1).reverse();
    },
    ratingStyle() {
      return {
        width: `${(this.value / this.stars) * 100}%`
      }
    },
    ratingClass() {
      return {
        'fa-2x': this.isMedium,
        'fa-3x': this.isLarge
      }
    }
  },
  methods: {
    updateRating(v) {
      this.$emit('input', v);
    }
  }
}
</script>

<style scoped>
.rating {
  display: block;
  font-size: 16px;
  position: relative;
  overflow: hidden;
}

.rating-wrapper {
  display: inline-block;
  position: relative;
  height: 19px;
}

.rating .rating-active {
  color: #ffc107;
  position: relative;
  z-index: 1;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}

.rating .rating-inactive {
  color: gainsboro;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-text-stroke: initial;
}
</style>